(function () {
  'use strict';

  var STORAGE_KEY = 'gutter_compare';
  var MODAL_PRODUCT_COL_WIDTH = 324;
  var COMPARE_BAR_MAX_SLOTS = 4;
  var barDismissed = false;

  function isCollectionPage() {
    return (
      document.body.classList.contains('template-collection') ||
      !!document.querySelector('[data-section-type="collection"]')
    );
  }

  function hideCompareBar() {
    var bar = getBar();
    if (!bar) return;
    bar.hidden = true;
    bar.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gutter-compare-bar-visible');
  }

  function dismissCompareBar() {
    barDismissed = true;
    hideCompareBar();
  }

  var productCache = Object.create(null);

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveState(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* ignore */
    }
  }

  function getBar() {
    return document.getElementById('gutter-compare-bar');
  }

  function getModal() {
    return document.getElementById('gutter-compare-modal');
  }

  function truncateTitle(title, max) {
    if (!title || title.length <= max) return title || '';
    return title.slice(0, max - 1) + '…';
  }

  function syncToggleButtons() {
    var items = loadState();
    var ids = items.map(function (item) {
      return String(item.id);
    });

    document.querySelectorAll('[data-compare-toggle]').forEach(function (btn) {
      var id = String(btn.getAttribute('data-compare-id'));
      var selected = ids.indexOf(id) !== -1;
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function getModalScrollStep() {
    var fromCss = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--compare-product-col-width'),
      10
    );
    return fromCss || MODAL_PRODUCT_COL_WIDTH;
  }

  function updateNavVisibility(trackEl, scope) {
    if (!trackEl) return;
    var root = scope === 'bar' ? getBar() : getModal();
    if (!root) return;

    var prev = root.querySelector('[data-compare-scroll="' + scope + '"][data-compare-direction="-1"]');
    var next = root.querySelector('[data-compare-scroll="' + scope + '"][data-compare-direction="1"]');
    var needsNav = trackEl.scrollWidth > trackEl.clientWidth + 2;

    if (prev) prev.hidden = !needsNav;
    if (next) next.hidden = !needsNav;
  }

  function scrollTrack(scope, direction) {
    var root = scope === 'bar' ? getBar() : getModal();
    if (!root) return;
    var track = root.querySelector('[data-compare-track="' + scope + '"]');
    if (!track) return;
    var step =
      scope === 'modal'
        ? getModalScrollStep()
        : (parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--gutter-compare-bar-slot-width'),
            10
          ) || 240) + 12;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
    window.setTimeout(function () {
      updateNavVisibility(track, scope);
    }, 300);
  }

  function getScrollHeaderOffset() {
    var header =
      document.querySelector('.shopify-section-group-header-group') ||
      document.getElementById('shopify-section-header');
    return header ? header.getBoundingClientRect().height + 16 : 16;
  }

  function scrollToProductGrid() {
    var target =
      document.querySelector('[data-section-type="collection"] .expandable-content__toggle') ||
      document.querySelector('[data-gutter-compare-grid]') ||
      document.querySelector('[data-section-type="collection"] .product-list--collection') ||
      document.querySelector('[data-section-type="search"] .product-list--collection') ||
      document.querySelector('.main-collection-cont .product-list--collection');

    if (!target) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    var offset = getScrollHeaderOffset();
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function renderBarSlots() {
    var bar = getBar();
    if (!bar) return;

    if (!isCollectionPage()) {
      hideCompareBar();
      return;
    }

    var track = bar.querySelector('[data-compare-track="bar"]');
    var countEl = bar.querySelector('[data-compare-bar-count]');
    var badgeEl = bar.querySelector('[data-compare-bar-badge]');
    var openBtn = bar.querySelector('[data-compare-open]');
    var openLabel = bar.querySelector('[data-compare-open-label]');
    var items = loadState();

    if (countEl) {
      countEl.textContent =
        items.length === 0
          ? '0 selected'
          : items.length + ' product' + (items.length === 1 ? '' : 's') + ' selected';
    }

    if (badgeEl) {
      if (items.length > 0) {
        badgeEl.textContent = items.length + ' of ' + COMPARE_BAR_MAX_SLOTS;
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }

    if (openBtn) {
      openBtn.disabled = items.length < 2;
    }

    if (openLabel) {
      openLabel.textContent = 'Compare (' + items.length + ')';
    }

    if (!track) return;
    track.innerHTML = '';

    items.forEach(function (item) {
      var slot = document.createElement('div');
      slot.className = 'gutter-compare-bar__slot';
      slot.innerHTML =
        (item.image
          ? '<img class="gutter-compare-bar__slot-image" src="' +
            escapeAttr(item.image) +
            '" alt="" loading="lazy">'
          : '<span class="gutter-compare-bar__slot-image gutter-compare-bar__slot-image--placeholder" aria-hidden="true"></span>') +
        '<span class="gutter-compare-bar__slot-title">' +
        escapeHtml(truncateTitle(item.title, 36)) +
        '</span>' +
        '<button type="button" class="gutter-compare-bar__slot-remove" data-compare-remove="' +
        escapeAttr(String(item.id)) +
        '" aria-label="Remove from compare"><span aria-hidden="true">×</span></button>';
      track.appendChild(slot);
    });

    var addProductBtn = document.createElement('button');
    addProductBtn.type = 'button';
    addProductBtn.className = 'gutter-compare-bar__add';
    addProductBtn.setAttribute('data-compare-add-product', '');
    addProductBtn.innerHTML =
      '<span class="gutter-compare-bar__add-label">+ Add product</span><span class="gutter-compare-bar__add-icon" aria-hidden="true">+</span>';
    track.appendChild(addProductBtn);

    document.documentElement.style.setProperty('--compare-product-count', String(Math.max(items.length, 1)));

    if (items.length === 0) {
      barDismissed = false;
      hideCompareBar();
    } else if (barDismissed) {
      hideCompareBar();
    } else {
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gutter-compare-bar-visible');
    }

    window.requestAnimationFrame(function () {
      updateNavVisibility(track, 'bar');
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function toggleProductFromButton(btn) {
    var payload = {
      id: btn.getAttribute('data-compare-id'),
      handle: btn.getAttribute('data-compare-handle'),
      title: btn.getAttribute('data-compare-title'),
      image: btn.getAttribute('data-compare-image'),
      url: btn.getAttribute('data-compare-url'),
    };

    var items = loadState();
    var idx = items.findIndex(function (item) {
      return String(item.id) === String(payload.id);
    });

    if (idx === -1) {
      items.push(payload);
      barDismissed = false;
    } else {
      items.splice(idx, 1);
    }

    saveState(items);
    syncToggleButtons();
    renderBarSlots();
  }

  function removeProduct(id) {
    var items = loadState().filter(function (item) {
      return String(item.id) !== String(id);
    });
    saveState(items);
    syncToggleButtons();
    renderBarSlots();
  }

  function clearAll() {
    barDismissed = false;
    saveState([]);
    syncToggleButtons();
    renderBarSlots();
    closeModal();
  }

  function buildCompareUrl(productUrl) {
    var url = productUrl.indexOf('http') === 0 ? productUrl : window.location.origin + productUrl;
    var parsed = new URL(url);
    parsed.searchParams.set('view', 'compare-card');
    return parsed.toString();
  }

  function fetchProductData(item) {
    var cacheKey = item.handle;
    if (productCache[cacheKey]) {
      return Promise.resolve(productCache[cacheKey]);
    }

    return fetch(buildCompareUrl(item.url))
      .then(function (res) {
        if (!res.ok) throw new Error('Fetch failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.getElementById('compare-product-data');
        if (!script || !script.textContent) throw new Error('No compare data');
        var data = JSON.parse(script.textContent);
        productCache[cacheKey] = data;
        return data;
      });
  }

  function renderStars(rating) {
    var r = Math.max(0, Math.min(5, Number(rating) || 0));
    var full = Math.floor(r);
    var half = r - full >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    return (
      '<span class="compare-table__stars compare-table__stars--dark" aria-hidden="true">' +
      '★'.repeat(full) +
      (half ? '⯨' : '') +
      '☆'.repeat(empty) +
      '</span>'
    );
  }

  var COMPARE_SPEC_ROWS = [
    { key: 'motors', label: 'Motors' },
    { key: 'motorPower', label: 'Motor power', highlight: 'numeric' },
    { key: 'voltage', label: 'Voltage' },
    { key: 'tankCapacity', label: 'Tank capacity', highlight: 'numeric' },
    { key: 'bodyMaterial', label: 'Body material' },
    { key: 'bestSuitedFor', label: 'Best suited for' },
    { key: 'rating', label: 'Rating', type: 'rating' },
    { key: 'availability', label: 'Availability', type: 'availability' },
  ];

  function parseNumericCompareValue(str) {
    if (!str) return NaN;
    var match = String(str).match(/([\d,.]+)/);
    return match ? parseFloat(match[1].replace(/,/g, '')) : NaN;
  }

  function getLeadingColumnIndices(products, key) {
    var values = products.map(function (product) {
      return parseNumericCompareValue(product[key]);
    });
    var valid = values.filter(function (value) {
      return !isNaN(value);
    });
    if (valid.length === 0) return [];
    var max = Math.max.apply(null, valid);
    var leaders = [];
    values.forEach(function (value, index) {
      if (value === max) leaders.push(index);
    });
    return leaders;
  }

  function buildProductHeaderCell(product) {
    var html = '<div class="compare-modal-product">';
    html += '<div class="compare-modal-product__media">';
    if (product.image) {
      html += '<img src="' + escapeAttr(product.image) + '" alt="">';
    }
    html += '</div>';
    html +=
      '<h3 class="compare-modal-product__title" title="' +
      escapeAttr(product.shortName || product.title) +
      '">' +
      escapeHtml(truncateTitle(product.shortName || product.title, 42)) +
      '</h3>';
    if (product.cardSubtitle) {
      html +=
        '<p class="compare-modal-product__subtitle">' +
        escapeHtml(product.cardSubtitle) +
        '</p>';
    }
    html += '<div class="compare-modal-product__price">';
    html += '<span class="compare-table__price">' + escapeHtml(product.priceFormatted || '') + '</span>';
    if (product.compareAtPrice && product.compareAtPrice > product.price) {
      html +=
        '<span class="compare-table__price-compare">' +
        escapeHtml(product.compareAtPriceFormatted || '') +
        '</span>';
    }
    html += '</div>';
    var disabled = !product.available ? ' disabled' : '';
    var cartLabel = product.available ? 'Add to cart' : 'Sold out';
    html +=
      '<button type="button" class="button button--primary compare-table__add-btn" data-compare-add-to-cart="' +
      escapeAttr(String(product.variantId)) +
      '"' +
      disabled +
      '>' +
      cartLabel +
      '</button>';
    html += '</div>';
    return html;
  }

  function buildSpecCellHtml(product, row, index, leaders) {
    if (row.type === 'rating') {
      return (
        renderStars(product.rating) +
        ' <span class="compare-table__rating-count">(' +
        escapeHtml(String(product.ratingCount || 0)) +
        ')</span>'
      );
    }
    if (row.type === 'availability') {
      var inStock = product.available;
      return (
        '<span class="compare-table__availability ' +
        (inStock ? 'compare-table__availability--in' : 'compare-table__availability--out') +
        '">' +
        (inStock
          ? '<span class="compare-table__availability-dot" aria-hidden="true"></span>In stock'
          : 'Out of stock') +
        '</span>'
      );
    }
    var value = product[row.key];
    var isLead = leaders.indexOf(index) !== -1 && value;
    return value
      ? '<span class="compare-table__spec-value' +
          (isLead ? ' compare-table__spec-value--lead' : '') +
          '">' +
          escapeHtml(value) +
          '</span>'
      : '—';
  }

  function buildComparisonTable(products) {
    document.documentElement.style.setProperty('--compare-product-count', String(products.length));

    var html = '<div class="compare-modal-layout">';
    html += '<div class="compare-modal-scroll" data-compare-modal-scroll>';
    html += '<table class="compare-table compare-table--matrix"><tbody>';

    html += '<tr class="compare-table__row--products">';
    html +=
      '<th class="compare-table__label-col compare-table__label-col--corner" scope="row"><span class="visually-hidden">Product</span></th>';
    products.forEach(function (product) {
      html +=
        '<td class="compare-table__product-col compare-table__product-col--head">' +
        buildProductHeaderCell(product) +
        '</td>';
    });
    html += '</tr>';

    COMPARE_SPEC_ROWS.forEach(function (row) {
      var leaders = row.highlight === 'numeric' ? getLeadingColumnIndices(products, row.key) : [];
      html += '<tr class="compare-table__row--spec">';
      html += '<th class="compare-table__label-col" scope="row">' + escapeHtml(row.label) + '</th>';
      products.forEach(function (product, index) {
        html +=
          '<td class="compare-table__product-col">' +
          buildSpecCellHtml(product, row, index, leaders) +
          '</td>';
      });
      html += '</tr>';
    });

    html += '</tbody></table></div>';
    html += '</div>';

    return html;
  }

  function openModal() {
    var items = loadState();
    if (items.length < 2) return;

    var modal = getModal();
    if (!modal) return;

    var wrap = modal.querySelector('[data-compare-table-wrap]');
    var subtitle = modal.querySelector('[data-compare-modal-subtitle]');
    if (subtitle) {
      subtitle.textContent =
        items.length + ' product' + (items.length === 1 ? '' : 's') + ' side by side';
    }
    if (wrap) {
      wrap.innerHTML = '<p class="gutter-compare-modal__loading">Loading comparison…</p>';
    }

    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gutter-compare-modal-open');

    Promise.all(items.map(fetchProductData))
      .then(function (products) {
        if (wrap) {
          wrap.innerHTML = buildComparisonTable(products);
        }
        var track = modal.querySelector('[data-compare-track="modal"]');
        if (track) {
          track.classList.remove('is-scrolled');
          track.scrollLeft = 0;
        }
        window.requestAnimationFrame(function () {
          updateNavVisibility(track, 'modal');
        });
      })
      .catch(function () {
        if (wrap) {
          wrap.innerHTML =
            '<p class="gutter-compare-modal__error">Could not load product data. Please try again.</p>';
        }
      });
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gutter-compare-modal-open');
  }

  function addToCart(variantId, button) {
    if (!variantId) return;
    button.disabled = true;
    var original = button.textContent;
    button.textContent = 'Adding…';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        button.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        button.textContent = 'Error';
        button.disabled = false;
        window.setTimeout(function () {
          button.textContent = original;
        }, 2000);
      });
  }

  function onDocumentClick(event) {
    var toggle = event.target.closest('[data-compare-toggle]');
    if (toggle) {
      event.preventDefault();
      toggleProductFromButton(toggle);
      return;
    }

    var removeBtn = event.target.closest('[data-compare-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeProduct(removeBtn.getAttribute('data-compare-remove'));
      return;
    }

    if (event.target.closest('[data-compare-clear]')) {
      event.preventDefault();
      clearAll();
      return;
    }

    if (event.target.closest('[data-compare-add-product]')) {
      event.preventDefault();
      scrollToProductGrid();
      return;
    }

    if (event.target.closest('[data-compare-open]')) {
      event.preventDefault();
      openModal();
      return;
    }

    if (event.target.closest('[data-compare-bar-close]')) {
      event.preventDefault();
      dismissCompareBar();
      return;
    }

    if (event.target.closest('[data-compare-close]')) {
      event.preventDefault();
      closeModal();
      return;
    }

    var scrollBtn = event.target.closest('[data-compare-scroll]');
    if (scrollBtn) {
      event.preventDefault();
      var scope = scrollBtn.getAttribute('data-compare-scroll');
      var dir = Number(scrollBtn.getAttribute('data-compare-direction')) || 1;
      scrollTrack(scope, dir);
      return;
    }

    var addBtn = event.target.closest('[data-compare-add-to-cart]');
    if (addBtn) {
      event.preventDefault();
      addToCart(addBtn.getAttribute('data-compare-add-to-cart'), addBtn);
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      var modal = getModal();
      if (modal && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    }
  }

  function init() {
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeydown);

    var barTrack = getBar() && getBar().querySelector('[data-compare-track="bar"]');
    if (barTrack) {
      barTrack.addEventListener('scroll', function () {
        updateNavVisibility(barTrack, 'bar');
      });
    }

    var modalTrack = getModal() && getModal().querySelector('[data-compare-track="modal"]');
    if (modalTrack) {
      modalTrack.addEventListener('scroll', function () {
        updateNavVisibility(modalTrack, 'modal');
        if (modalTrack.scrollLeft > 4) {
          modalTrack.classList.add('is-scrolled');
        } else {
          modalTrack.classList.remove('is-scrolled');
        }
      });
    }

    window.addEventListener('resize', function () {
      if (barTrack) updateNavVisibility(barTrack, 'bar');
      if (modalTrack) updateNavVisibility(modalTrack, 'modal');
    });

    syncToggleButtons();
    renderBarSlots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
